
export interface DynamicObject {
    [key: string]: any
}

export const randomKeyString = () => {
    return Math.random().toString(36).substring(2, 9);
}
